import {useEffect, useState} from 'react';

const MOBILE_BREAKPOINT = 768;

type UseIsMobileProps = {
  breakpoint?: number;
};

export function useIsMobile({breakpoint = MOBILE_BREAKPOINT}: UseIsMobileProps = {}) {
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };

    setIsMobile(window.innerWidth < breakpoint);

    if (!mediaQuery) {
      return;
    }

    mediaQuery.addEventListener('change', onChange);

    return () => {
      mediaQuery.removeEventListener('change', onChange);
    };
  }, [breakpoint]);

  return !!isMobile;
}
